// extracted by mini-css-extract-plugin
module.exports = {"TeamProjectScene":"TeamProjectScene_TeamProjectScene__3gR4W","list":"TeamProjectScene_list__1st3s","item":"TeamProjectScene_item__3KBZ8","spacer":"TeamProjectScene_spacer__3oFWj"};